import { render } from "./MyShrunkButton.vue?vue&type=template&id=ef827086&scoped=true"
import script from "./MyShrunkButton.vue?vue&type=script&lang=js"
export * from "./MyShrunkButton.vue?vue&type=script&lang=js"

import "./MyShrunkButton.vue?vue&type=style&index=0&id=ef827086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef827086"]])

export default __exports__